import { RootState } from '../store';

export const selectIsPremium = (state: RootState): boolean =>
  state.user.isPremium;
